import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ButtonBase } from "@material-ui/core";
import {
  ConvertJsonV2Component,
  Spinner,
  TabsComponent,
  PermissionsComponent,
} from "../../../../../../Components";
import {
  unitDetailsPut,
  unitDetailsGet,
  GetAllFormFieldTabsByFormId,
  GetAllUnitLeadOwners,
} from "../../../../../../Services";
import {
  bottomBoxComponentUpdate,
  FormErrorsHandler,
  formItemsBuilder,
  GetParams,
  GlobalHistory,
  showError,
  showSuccess,
  showWarn
} from "../../../../../../Helper";
import { LookupsRules } from "../../../../../../Rule";
import { UnitsOperationTypeEnum } from "../../../../../../Enums";

import { LeadOwnerUnitSalePermissions } from "../../../../../../Permissions";
import { SellerInfo } from "../../Common/SellerInfo/SellerInfo";
import { PropertyInfo } from "./PropertyInfo/PropertyInfo";

export const UnitInformationComponent = ({
  viewType,
  parentTranslationPath,
  translationPath,
  save,
  isDetailsDialog,
  isActiveToSave,
  isOpen,
  isOpenChanged,
  onSave,
  isOpenInsideForm,
  unitEmptyFields,
  reloadData,
  unitOpertaionTypeValue 
}) => {
  const { t } = useTranslation(parentTranslationPath, "Shared");
  const location = useLocation();
  const [activeItem, setActiveItem] = useState({
    id: null,
    userTypeId: null,
  });
  const [reload, setReload] = useState(false);
  const [unitLeaseInfo , setUnitLeaseInfo] = useState(null) ;
  const [newErrorsList, setNewErrorsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hiddenTabByOperationType, setHiddenTabByOperationType] =
    useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loadings, setLoadings] = useState([]);
  const [formData, setFormData] = useState([]);
  const [enumsInitFinished, setEnumsInitFinished] = useState(false);
  const [errors, setErrors] = useState([]);
  const [unitInitDetails, setUnitInitDetails] = useState({});
  const [unitDetails, setUnitDetails] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [formAndTabs, setFormAndTabs] = useState([]);
  const [leadOwner, setLeadOwner] = useState(null);
  const [unitPropertyId, setUnitPropertyId] = useState(null);
  const [leaseLeadOwner, setLeaseLeadOwner] = useState(null);
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const [unitLeadReferredById] = useState(
    loginResponse && loginResponse.userId
  );

  const onTabChanged = (e, newTap) => {
    setEnumsInitFinished(false);
    setActiveTab(newTap);
  };

  const getAllFormFieldTabsByFormId = useCallback(async () => {
    setIsLoading(true);
    const result = await GetAllFormFieldTabsByFormId({ formId: 14 });
    if (!(result && result.status && result.status !== 200))
      setFormAndTabs(result[0] || []);
    else setFormAndTabs([]);
    setIsLoading(false);
  }, []);
  const getUnitDetails = useCallback(async () => {
    setIsLoading(true);
    const unitDetailsRes = await unitDetailsGet({ id: activeItem.id });
    if (
      !(
        unitDetailsRes &&
        unitDetailsRes.status &&
        unitDetailsRes.status !== 200
      )
    ) {
      if (unitDetailsRes && unitDetailsRes.unit) {
        setUnitInitDetails(JSON.parse(JSON.stringify(unitDetailsRes)));
        setUnitPropertyId(unitDetailsRes.unit?.property_name?.id);
      }
      setUnitDetails(unitDetailsRes);
    } else {
      setUnitInitDetails({});
      setUnitDetails({});
    }
    setIsLoading(false);
  }, [activeItem]);

  const getUnitLeadOwner = useCallback(async (id) => {
    setIsLoading(true);
    const res = await GetAllUnitLeadOwners(id);
    if (!(res && res.status && res.status !== 200)) {
      setLeadOwner(res.leadOwner);
      setLeaseLeadOwner(res.leaseLeadOwner);
    } else {
      setLeadOwner(null);
      setLeaseLeadOwner(null);
    }
    setIsLoading(false);
  }, []);
  
  const updateRentPriceSqFt = () => {
    let rentPriceObj = null;
    if (
      unitDetails?.unit?.operation_type?.lookupItemName !== "Sale" &&
      unitDetails?.unit?.rent_price_fees
    ) {
      rentPriceObj = {
        ...unitDetails.unit.rent_price_fees,
        rentPerSq:
          unitDetails?.unit?.builtup_area_sqft &&
          unitDetails.unit.builtup_area_sqft !== '' &&
          unitDetails.unit.rent_price_fees?.rentPerYear
            ? parseInt(
                (
                  unitDetails.unit.rent_price_fees.rentPerYear /
                  unitDetails.unit.builtup_area_sqft
                )
              )
            : 0,
      };
    }
    return rentPriceObj;
  };
  
  const dataHandler = useCallback(() => {
    if (formData.length === 0)
      setFormData(formItemsBuilder(unitDetails.unit, formAndTabs));
  }, [unitDetails.unit, formAndTabs, formData.length]);
  const cancelHandler = () => {
    GlobalHistory.goBack();
    // GlobalHistory.push(`/home/units-sales/view`)
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps

  const saveHandler = async () => {
    setIsSubmitted(true);
    if (onSave) onSave(false);
    if (errors && errors.length > 0) {
      const firstErrorTapIndex = newErrorsList.findIndex(
        (item) =>
          item.findIndex((element) => element.field.id === errors[0].key) !== -1
      );

      if (firstErrorTapIndex !== -1) {
        setActiveTab(
          (hiddenTabByOperationType !== null &&
            firstErrorTapIndex >= hiddenTabByOperationType[0] &&
            activeTab >= hiddenTabByOperationType[1] &&
            firstErrorTapIndex + 1) ||
            firstErrorTapIndex
        );
      }
      showError(errors[0].message);
      return;
    }
    const totalItems = formData.reduce(
      (total, items) => total + items.length,
      0
    );
    const totalValues = Object.values(unitDetails.unit).filter(
      (item) =>
        item !== null &&
        item !== "" &&
        item !== undefined &&
        item !== " " &&
        !(Object.keys(item).length === 0 && item.constructor === Object)
    ).length;
    const totalValues2 = totalValues - 2;
    const total = (totalValues2 / totalItems) * 100;
    const dataCompleted = Math.round(total);
    unitDetails.unit.data_completed = dataCompleted > 100 ? 100 : dataCompleted;
    const rentPrice = updateRentPriceSqFt();
    const newOwners = [];
    if (
      unitDetails &&
      unitDetails.unit &&
      (!unitDetails.unit.owner || !unitDetails.unit.owner.length) &&
      (unitDetails.unit.lease_lead_owner || unitDetails.unit.lead_owner)
    )
      newOwners.push(
        (unitDetails && unitDetails.unit.lead_owner) ||
          unitDetails.unit.lease_lead_owner
      );
    const unitUpdated = {
      ...unitDetails.unit,
      owner: newOwners,
      rent_price_fees: rentPrice,
    };
    const unitUpdateWithNewOwners = { ...unitDetails, unit: unitUpdated };
    const updatedUnitLeadOwnerId =
      unitDetails &&
      unitDetails.unit &&
      unitDetails.unit.lead_owner &&
      unitDetails.unit.lead_owner.id;
    const updatedUnitLeaseLeadOwnerId =
      unitDetails &&
      unitDetails.unit &&
      unitDetails.unit.lease_lead_owner &&
      unitDetails.unit.lease_lead_owner.id;
    const unitLeadOwnerId = leadOwner && leadOwner.contactId;
    const unitLeaseLeadOwnerId = leaseLeadOwner && leaseLeadOwner.contactId;

    const referredById =
      !(
        updatedUnitLeadOwnerId === unitLeadOwnerId || !updatedUnitLeadOwnerId
      ) ||
      !(
        updatedUnitLeaseLeadOwnerId === unitLeaseLeadOwnerId ||
        !updatedUnitLeaseLeadOwnerId
      )
        ? unitLeadReferredById
        : null;

    setIsLoading(true);
     const newUnitUpdate = {
       unit: unitDetails?.unit
         ? {
             ...unitDetails?.unit,
             rent_price_fees: rentPrice,
           }
         : null,
     };
    const putResponse = await unitDetailsPut({
      id: activeItem.id,
      body: {
        unitJson: newOwners.length ? unitUpdateWithNewOwners : unitDetails?.unit?.operation_type?.lookupItemName !== 'Sale' ? newUnitUpdate :unitDetails ,
        rowVersion: unitDetails.rowVersion,
      },
      referredById,
      skipSensitiveDataCheck: true,
    });
    if (!(putResponse && putResponse.status && putResponse.status !== 200)) {
      showSuccess(t(`${translationPath}unit-updated-successfully`));
      if (reloadData) reloadData();
      setReload(true);
      setIsLoading(false);
      if (isOpenChanged) {
        isOpenChanged();
      }
      // cancelHandler();
    } else {
      setIsLoading(false);
      let errorMsg =
        putResponse &&
        putResponse.data &&
        putResponse.data.Message &&
        putResponse.data.Message.split(":") &&
        putResponse.data.Message.split(":").pop();
      showError(
        `${t(
          `${translationPath}${errorMsg.substring(
            0,
            errorMsg.lastIndexOf(" ")
          )}`
        )}${errorMsg.substring(errorMsg.lastIndexOf(" "), errorMsg.length)}`
      );
    }
  };
  const onLoadingsChanged = (value, key) => {
    setLoadings((items) => {
      const itemIndex = items.findIndex((item) => item.key === key);
      if (value) {
        const addItem = {
          key,
          value,
        };
        if (itemIndex !== -1) items[itemIndex] = addItem;
        else items.push(addItem);
      } else if (itemIndex !== -1) items.splice(itemIndex, 1);
      return [...items];
    });
  };
  const onItemChanged =
    (item, index) => (newValue, itemIndex, itemKey, parentItemKey) => {
      setFormData((elements) => {
        if (parentItemKey) {
          if (itemIndex !== undefined) {
            elements[
              (hiddenTabByOperationType !== null &&
                activeTab >= hiddenTabByOperationType[0] &&
                activeTab >= hiddenTabByOperationType[1] &&
                activeTab + 1) ||
                activeTab
            ][itemIndex][parentItemKey][itemKey] = newValue;
          } else {
            elements[
              (hiddenTabByOperationType !== null &&
                activeTab >= hiddenTabByOperationType &&
                activeTab + 1) ||
                activeTab
            ][index][parentItemKey][itemKey] = newValue;
          }
        } else if (itemIndex) {
          elements[
            (hiddenTabByOperationType !== null &&
              activeTab >= hiddenTabByOperationType &&
              activeTab + 1) ||
              activeTab
          ][itemIndex][itemKey] = newValue;
        } else {
          elements[
            (hiddenTabByOperationType !== null &&
              activeTab >= hiddenTabByOperationType[0] &&
              activeTab >= hiddenTabByOperationType[1] &&
              activeTab + 1) ||
              activeTab
          ][index][itemKey] = newValue;
        }
        return [...elements];
      });
    };
  const onValueChanged = (item) => (newValue, itemIndex, itemKey) => {
    setUnitDetails((items) => {
      if (itemKey) items.unit[itemKey] = newValue;
      else if ((itemIndex || itemIndex === 0) && itemIndex !== -1) {
        items.unit[
          formData[
            (hiddenTabByOperationType !== null &&
              activeTab >= hiddenTabByOperationType[0] &&
              activeTab >= hiddenTabByOperationType[1] &&
              activeTab + 1) ||
              activeTab
          ][itemIndex].field.id
        ] = newValue;
      } else items.unit[item.field.id] = newValue;
      return { ...items };
    });
  };

  const lookupInit = useCallback(() => {
    setIsLoading(true);
    const haveHideTab =
      hiddenTabByOperationType &&
      unitDetails &&
      unitDetails.unit &&
      unitDetails.unit.operation_type &&
      unitDetails.unit.operation_type &&
      unitDetails.unit.operation_type &&
      unitDetails.unit.operation_type.lookupItemName === "Sale" &&
      activeTab === 4
        ? true
        : false;

    const result = LookupsRules(
      !haveHideTab
        ? formData[
            (hiddenTabByOperationType !== null &&
              activeTab >= hiddenTabByOperationType[0] &&
              activeTab >= hiddenTabByOperationType[1] &&
              activeTab + 1) ||
              activeTab
          ]
        : formData[5],
      unitDetails.unit,
      onLoadingsChanged
    );
    setFormData((items) => {
      items.splice(
        !haveHideTab
          ? (hiddenTabByOperationType !== null &&
              activeTab >= hiddenTabByOperationType[0] &&
              activeTab >= hiddenTabByOperationType[1] &&
              activeTab + 1) ||
              activeTab
          : hiddenTabByOperationType[0] + 1,
        1,
        result
      );
      return [...items];
    });
    setIsLoading(false);
  }, [formData, hiddenTabByOperationType, activeTab, unitDetails.unit, errors]);

  useEffect(() => {
    if (formData.length > 0 && unitDetails.unit) {
      const newErrorsListUnitForm = hiddenTabByOperationType
        ? formData.filter(function (item, index) {
            return !hiddenTabByOperationType.includes(index);
          })
        : [...formData];

      setNewErrorsList(newErrorsListUnitForm);

      setErrors(FormErrorsHandler(newErrorsListUnitForm, unitDetails.unit));
    }
  }, [unitDetails, formData, hiddenTabByOperationType]);

  useEffect(() => {
    if (!enumsInitFinished && formData.length > 0) {
      setEnumsInitFinished(true);
      lookupInit();
    }
  }, [activeTab, enumsInitFinished, formData.length, lookupInit]);
  useEffect(() => {
    if (unitDetails.unit) dataHandler();
  }, [unitDetails.unit, dataHandler]);
  useEffect(() => {
    if (formAndTabs.length > 0) getUnitDetails();
  }, [formAndTabs, getUnitDetails]);
  useEffect(() => {
    if (activeItem && activeItem.userTypeId) getAllFormFieldTabsByFormId();
  }, [activeItem, getAllFormFieldTabsByFormId]);
  useEffect(() => {
    if (isDetailsDialog) {
      const obj = JSON.parse(localStorage.getItem("current"));
      setActiveItem({
        id: obj.id,
        userTypeId: obj.type,
      });
    } else {
      setActiveItem({
        id: GetParams("id"),
        userTypeId: GetParams("formType"),
      });
    }
    getUnitLeadOwner(GetParams("id"));
  }, [location]);

  useEffect(() => {
    if (save && isActiveToSave) saveHandler();
  }, [save]);

  useEffect(() => {
    if (!isOpen)
      bottomBoxComponentUpdate(
        <div className="d-flex-v-center-h-end flex-wrap ">
          <ButtonBase
            className="btns theme-transparent mb-2"
            onClick={cancelHandler}
          >
            <span>{t("Shared:cancel")}</span>
          </ButtonBase>
          <PermissionsComponent
            permissionsList={Object.values(LeadOwnerUnitSalePermissions)}
            permissionsId={
              LeadOwnerUnitSalePermissions.EditUnitDetails.permissionsId
            }
          >
            <ButtonBase className="btns theme-solid mb-2" onClick={saveHandler}>
              <span>{t("Shared:save")}</span>
            </ButtonBase>
          </PermissionsComponent>
        </div>
      );
  }, [saveHandler, t]);
  useEffect(() => {
    if (
      unitDetails.unit &&
      unitDetails.unit.operation_type &&
      unitDetails.unit.operation_type.lookupItemId ===
        UnitsOperationTypeEnum.sale.key
    )
      setHiddenTabByOperationType([4, 6]);
    else if (
      unitDetails.unit &&
      unitDetails.unit.operation_type &&
      unitDetails.unit.operation_type.lookupItemId ===
        UnitsOperationTypeEnum.rent.key
    )
      setHiddenTabByOperationType([3, 5]);
    else setHiddenTabByOperationType(null);
  }, [unitDetails]);

  // useEffect(
  //   () => () => {
  //     bottomBoxComponentUpdate(null);
  //   },
  //   []
  // );
  useEffect(() => {
    if (
      unitDetails.unit &&
      unitDetails.unit.operation_type &&
      unitDetails.unit.operation_type.lookupItemId ===
        UnitsOperationTypeEnum.sale.key
    )
      setHiddenTabByOperationType([4, 6]);
    else if (
      unitDetails.unit &&
      unitDetails.unit.operation_type &&
      unitDetails.unit.operation_type.lookupItemId ===
        UnitsOperationTypeEnum.rent.key
    )
      setHiddenTabByOperationType([3, 5]);
    else setHiddenTabByOperationType(null);
  }, [unitDetails]);

  return (
    <div className="units-information-wrapper childs-wrapper b-0">
      <Spinner isActive={isLoading} isAbsolute />
      <TabsComponent
        data={formAndTabs}
        labelInput="tab"
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        themeClasses="theme-curved"
        currentTab={activeTab}
        hiddenTabIndexes={
          (hiddenTabByOperationType !== null && hiddenTabByOperationType) || []
        }
        onTabChanged={onTabChanged}
      />
      <div className="tabs-content-wrapper">
        {formData &&
          formData[activeTab] &&
          formData[
            (hiddenTabByOperationType !== null &&
              (activeTab >= hiddenTabByOperationType[0] ||
                activeTab >= hiddenTabByOperationType[1]) &&
              activeTab + 1) ||
              activeTab
          ]
            .filter(
              (item) =>
                viewType === 1 ||
                (viewType === 2 &&
                  ((unitEmptyFields &&
                    unitEmptyFields[item.field.id] === null) ||
                    (unitEmptyFields &&
                      unitEmptyFields[item.field.id] === undefined) ||
                    (unitEmptyFields && unitEmptyFields[item.field.id] === "")))
            )
            .map((item, index) => (
              <ConvertJsonV2Component
                key={`form${index + 1}-${activeTab}`}
                item={item}
                allItems={
                  formData[
                    (hiddenTabByOperationType !== null &&
                      (activeTab >= hiddenTabByOperationType[0] ||
                        activeTab >= hiddenTabByOperationType[1]) &&
                      activeTab + 1) ||
                      activeTab
                  ]
                }
                allItemsValues={unitDetails.unit}
                itemValue={
                  unitDetails.unit[item.field.id] === 0
                    ? "0"
                    : unitDetails.unit[item.field.id]
                }
                isSubmitted={isSubmitted}
                onItemChanged={onItemChanged(item, index)}
                onValueChanged={onValueChanged(item, index)}
                helperText={
                  (errors.find((element) => element.key === item.field.id) &&
                    errors.find((element) => element.key === item.field.id)
                      .message) ||
                  ""
                }
                error={
                  errors.findIndex(
                    (element) => element.key === item.field.id
                  ) !== -1
                }
                isLoading={
                  loadings.findIndex(
                    (element) => element.key === item.field.id && element.value
                  ) !== -1
                }
                onLoadingsChanged={onLoadingsChanged}
                setIsLoading={setIsLoading}
                reload={reload}
                save={save}
                isOpenInsideForm={isOpenInsideForm}
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                unitOpertaionTypeValue={unitOpertaionTypeValue}
                itemType={{ type: "unit", name: "saleUnit" }}
              />
            ))}
      </div>
      <div className="information-container">
        {leadOwner && (
          <SellerInfo
            leadOwner={leadOwner}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
          />
        )}
        {unitPropertyId && (
          <PropertyInfo
            propertyId={unitPropertyId}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            builtupAreaSqft={unitDetails?.unit?.builtup_area_sqft || 0}
          />
        )}
      </div>
    </div>
  );
};

UnitInformationComponent.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  viewType: PropTypes.number.isRequired,
  save: PropTypes.bool,
  isDetailsDialog: PropTypes.bool,
  isActiveToSave: PropTypes.bool,
  isOpen: PropTypes.bool,
  isOpenChanged: PropTypes.func,
  onSave: PropTypes.func,
};

UnitInformationComponent.defaultProps = {
  save: false,
  isDetailsDialog: false,
  isActiveToSave: false,
  isOpen: false,
  isOpenChanged: undefined,
  onSave: undefined,
};
